import { useApp } from '../context.js';

// Shown after "✓ Complete" on a planned date and the "How was it?" rating: offer a round of Guess the Check.
export default function AfterDateSheet() {
    const { afterDate, playAfterDate, restaurants, skipAfterDate } = useApp();
    if (!afterDate) return null;
    const r = restaurants.find(x => x.id === afterDate.restaurantId);
    return (
        <div className="fixed inset-0 bg-black/50 flex items-end sm:items-center justify-center p-4 z-50" onClick={skipAfterDate}>
            <div className="bg-white apple-card rounded-3xl p-6 max-w-sm w-full shadow-2xl text-center animate-fadeIn" onClick={(e) => e.stopPropagation()}>
                <div className="text-4xl mb-2">💰</div>
                <h2 className="text-2xl font-bold text-gray-800 mb-1">Guess the Check?</h2>
                <p className="text-sm text-gray-500 mb-5">{r ? `One round for ${r.name} before you look at the bill.` : 'One round before you look at the bill.'}</p>
                <div className="flex gap-2">
                    <button onClick={skipAfterDate} className="flex-1 bg-gray-200 text-gray-700 px-4 py-3 rounded-xl font-semibold apple-button">
                        Not tonight
                    </button>
                    <button onClick={playAfterDate} className="flex-1 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-4 py-3 rounded-xl font-semibold apple-button">
                        Let's play!
                    </button>
                </div>
            </div>
        </div>
    );
}
